import firebase from 'firebase/compat/app';

import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export const cloudFunctions = firebase.functions();
export const db = firebase.firestore();

export const storage = firebase.storage();
// Firebase emulator setup
if (process.env.REACT_APP_USE_FIREBASE_EMULATOR?.toLowerCase() === 'true') {
  console.debug('----------------- USING FIREBASE EMULATOR ---------------');
  // db.settings({
  //   host: 'localhost:8088',
  //   ssl: false
  // });
  firebase.functions().useFunctionsEmulator('http://localhost:5001');
  // auth.useEmulator('http://localhost:9099');
}

